import React from "react";
import hibernatePng from "../img/hibernate_logo_icon_171004.png";

export default function Skills() {
  return (
    <div className="container text-center skills-card" id="skills">
      <hr />
      <h5 className="card-title IBM-Plex-Mono fs-3 ">Skills</h5>
      <hr />
      <br />
      <h5 className="card-title IBM-Plex-Mono fs-3 ">Languages</h5>
      <br />
      <br />
      <div className="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/79/5e/bb/795ebb5f4a470cd7242136237f61fc53.png"
              className="skill-img border border-warning bg-gradient text-emphasis-danger skills-card-img box-shodw"
              alt="java"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Java</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/5a/10/dc/5a10dc26f67f4217c22136dbd69dbc47.jpg"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="js"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">JavaScript</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "40%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/f3/33/77/f33377bd69bb2466408950e36de3ad1a.jpg"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="html"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">HTML</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/3f/83/9a/3f839a4a5688116dfb5f9f81eaa8d067.png"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="css"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">CSS</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/09/7b/34/097b349ab1d78c15744c3a89ff457939.png"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="mysql"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">MySql</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "60%" }} />
          </div>
        </div>

        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=256&id=4PiNHtUJVbLs&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="bootstrap"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Tailwind CSS</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={15}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "40%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=80&id=25Sjy8fKExYA&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">ReactJS</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "15%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src={hibernatePng}
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw pt-1 pb-1"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Hibernate</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "40%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/color/256/spring-logo.png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Spring Framework</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "50%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=256&id=qV-JzWYl9dzP&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Django</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "50%" }} />
          </div>
        </div>

        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=256&id=13441&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Python</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "50%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=256&id=74402&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">MongoDB</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "50%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://img.icons8.com/?size=256&id=BUnExfsRs3CW&format=png"
              className="skill-img border border-warning bg-dark bg-gradient skills-card-img box-shodw"
              alt="reactjs"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">VueJS</p>
          <div
            className="progress "
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar " style={{ width: "50%" }} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <h5 className="card-title IBM-Plex-Mono fs-3 ">Tools</h5>
      <br />
      <br />

      <div className="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/originals/a3/3f/3f/a33f3f15417a2afd5441e9325fa9a546.png"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="git"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Git & GitHub</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "50%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://i.pinimg.com/236x/3e/e6/61/3ee661651b67b1888a41209b6a70cf78.jpg"
              className="skill-img border border-warning  bg-gradient skills-card-img box-shodw"
              alt="vscode"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">VS Code</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://spring.io/img/projects/spring-tool.svg"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="eclipse"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Spring Tool Suite</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://cdn.icon-icons.com/icons2/1381/PNG/512/intellij_93550.png"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="eclipse"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Intellij Idea</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
        <div className="col">
          <div className="p-3 skilszoom">
            <img
              src="https://cdn.icon-icons.com/icons2/1381/PNG/512/mysqlworkbench_93532.png"
              className="skill-img border border-warning bg-gradient skills-card-img box-shodw"
              alt="eclipse"
            />
          </div>

          <p className="skills-card-name IBM-Plex-Mono">Mysql Workbench</p>
          <div
            className="progress"
            role="progressbar"
            aria-label="Basic example"
            aria-valuenow={25}
            aria-valuemin={0}
            aria-valuemax={100}
          >
            <div className="progress-bar" style={{ width: "70%" }} />
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
}
